export var socket = null
export const setSocket = (io) => {
    socket = io
}
export const resetSocket = () => {
    socket = null
}